import styled, { css } from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "../../common.styles";
import { headerAndFooterHeight, sidePanelWidth } from "../AddProjectMainView.styles";
import { colors } from "healthex-common/colors";
import { BoldText, Text, LighterText, TinyText, SemiBoldText, Subtitle } from "../../HXDesktopPage.styles";
import { fontWeights } from "healthex-common/weights";
import { HXAccordion } from "../../HXAccordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Check from "@mui/icons-material/Check";
import Warning from "@mui/icons-material/Warning";
import Lock from "@mui/icons-material/Lock";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "../../HXMobilePage.styles";
import { ScrollLink } from "react-scroll";
import Chip from "@mui/material/Chip";
import { fontSizes } from "healthex-common/sizes";
import ExpandMore from "@mui/icons-material/ExpandMore";
export const navSectionsContainerId = "nav-sections";
export const navSectionId = "nav-section-:sectionName";
export const navSectionExtraOffset = 16;
const logoContainerHorizontalPadding = "32px";
const logoGap = "17px";
export const AddProjectSidePanelContainer = styled(FlexColumn) `
    width: ${sidePanelWidth};
    gap: 16px;
    border-right: 1px solid ${colors.black_12};
    background: ${colors.white_main};
    flex-shrink: 0;
`;
export const AddProjectSidePanelHeaderContainer = styled(FlexRow) `
    position: fixed;
    height: ${headerAndFooterHeight};
    width: ${sidePanelWidth};
    box-sizing: border-box;
    padding: 24px ${logoContainerHorizontalPadding};
    align-items: center;
    align-self: stretch;
    gap: 48px;
    border-bottom: 1px solid ${colors.black_12};
    background: ${colors.white_main};
    z-index: 10;

    & img {
        max-width: calc((${sidePanelWidth} - (${logoContainerHorizontalPadding}*2) - ${logoGap}) / 2);
    }
`;
export const AddProjectSidePanelContentContainer = styled(FlexColumn) `
    margin-top: ${headerAndFooterHeight};
    padding: 16px 0;
    width: ${sidePanelWidth};
    align-self: stretch;
    flex: 1 0 0;
    overflow-y: auto;
`;
export const AddProjectSidePanelContent = styled(FlexColumn) `
    gap: 0px;
    flex: 1 0 0;
`;
export const AddProjectSidePanelNavItemContainer = styled(FlexRow) `
    gap: 6px;
    min-height: 43px;
    padding: 8px 24px 8px 32px;
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    cursor: default;

    &:hover {
        ${(props) => props.showHoverBackground &&
    css `
                background: ${colors.navy_4};
            `}

        ${(props) => props.enabled &&
    css `
                cursor: pointer;
            `}
    }

    ${(props) => props.selected &&
    css `
            background: ${colors.navy_8} !important;
        `}
`;
export const AddProjectSidePanelNavItemContainerLink = ScrollLink(AddProjectSidePanelNavItemContainer);
export const AddProjectSidePanelNavItemText = styled(BoldText) `
    align-self: stretch;
    padding: 4px 0;
    flex: 1 0 0;

    ${(props) => props.disabled &&
    css `
            color: ${colors.black_lighter};
        `}
`;
export const AddProjectSidePanelSubNavItemText = styled(Text) `
    align-self: stretch;
    padding: 4px 0;
    flex: 1 0 0;

    ${(props) => props.disabled &&
    css `
            color: ${colors.black_lighter};
        `}
`;
export const AddProjectSidePanelSubNavItemLighterText = styled(LighterText) `
    align-self: stretch;
    padding: 4px 0;
    flex: 1 0 0;
`;
export const AddProjectSidePanelPagesAccordion = styled(HXAccordion) `
    align-self: stretch;

    &:before {
        height: 0;
    }
`;
export const AddProjectSidePanelPagesAccordionSummary = styled(AccordionSummary) `
    &.MuiAccordionSummary-root {
        padding: 0px;
        border-width: 0px;
        padding-right: 24px;
    }
`;
export const AddProjectSidePanelPagesAccordionDetails = styled(AccordionDetails) `
    &.MuiAccordionDetails-root {
        padding: 0;
    }
`;
export const AddProjectSidePanelSubNavItemCompletedIcon = styled(Check) `
    color: ${colors.black_lighter};
    width: 24px;
    height: 24px;
`;
export const AddProjectSidePanelSubNavItemPlaceholderForIcon = styled.div `
    width: 24px;
    height: 24px;
    background: transparent;
`;
export const AddProjectSidePanelSubNavItemLockIcon = styled(Lock) `
    color: ${colors.black_lighter};
    width: 24px;
    height: 24px;
`;
export const AddProjectSidePanelSubNavItemWarningIcon = styled(Warning) `
    color: ${colors.sunset_main};
    width: 24px;
    height: 24px;
`;
export const AddProjectSidePanelSubNavItemRequired = styled.span `
    &:after {
        color: ${colors.tulip_main};
        content: "*";
    }
`;
export const AddProjectSidePanelNavItemBadge = styled(TinyText) `
    background: ${colors.accents_sunset};
    color: ${colors.white_main};
    padding: 0 6.5px;
    text-transform: uppercase;
    border-radius: 100px;
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.14px;
`;
export const StudyRequirementParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) ``;
export const StudyRequirementsContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    flex: 1 0 0;
    padding: 0 24px 20px 24px;
    gap: 32px;
`;
export const StudyRequirementTitle = styled(SemiBoldText) `
    width: 300px;
`;
export const StudyRequirementsFooterContainer = styled(FlexRowDiv) `
    padding: 16px 24px;
    border-top: 1px solid ${colors.black_12};
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const StudyRequirementsEditContainer = styled(FlexColumn) `
    overflow-y: auto;
`;
export const StudyRequirementsEditContent = styled(FlexColumn) `
    padding: 0 24px 24px 24px;
    gap: 32px;
`;
export const StudyRequirementEditTitleLocked = styled(Lock) `
    width: 24px;
    height: 24px;
    color: ${colors.black_main};
`;
export const AddProjectSidePanelBottonContainer = styled(FlexColumnDiv) `
    padding: 24px 24px 24px 32px;
    justify-content: center;
    gap: 16px;
    border-top: 1px solid ${colors.black_12};

    box-sizing: border-box;
    width: ${sidePanelWidth};
`;
export const ActivateProjectDialogContent = styled(FlexColumnDiv) `
    padding: 8px 24px 0px 24px;
    gap: 24px;

    & .MuiTextField-root {
        align-self: stretch;
    }
`;
export const ActivateProjectDialogRequiredFieldLabel = styled(BoldText) `
    &:after {
        margin-left: 4px;
        color: ${colors.tulip_main};
        content: "*";
    }
`;
export const ActivateProjectDialogButtons = styled(FlexRowDiv) `
    margin-top: 24px;
    padding: 16px 0px;
    border-top: 1px solid ${colors.black_12};
    justify-content: flex-end;
`;
export const AddProjectFrequentlyAskedQuestionsAccordion = styled(HXAccordion) `
    align-self: stretch;

    &:before {
        height: 0;
    }
`;
export const AddProjectFrequentlyAskedQuestionsAccordionSummary = styled(AccordionSummary) `
    &.MuiAccordionSummary-root {
        padding: 0px;
        min-height: 40px !important;
        border-width: 0px;
    }
`;
export const AddProjectFrequentlyAskedQuestionsAccordionDetails = styled(AccordionDetails) `
    &.MuiAccordionDetails-root {
        padding: 0;
    }
    white-space: pre-wrap;
    margin-top: 8px;
`;
export const AddProjectFrequentlyAskedQuestionsSubtitle = styled(Subtitle).attrs({ variant: "outlined", size: "small" }) `
    font-size: ${fontSizes.MEDIUM};
    line-height: normal;
    flex: 1;
`;
export const AddProjectFrequentlyAskedQuestionsViewOnlyChip = styled(Chip).attrs({ variant: "outlined", size: "small" }) `
    margin-right: 4px;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    border-color: ${colors.navy_12};
    letter-spacing: 0.17px;
    line-height: normal;
`;
export const AddProjectFrequentlyAskedQuestionsExpandMoreIcon = styled(ExpandMore) `
    padding: 8px;
    width: 24px;
    height: 24px;
    margin-right: 4px;
`;
